// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #022423 0%, #034544 50%, #022423 100%);
  direction: rtl;
  font-family: 'Cairo', Arial, sans-serif;
}

.login-box {
  background: white;
  border-radius: 20px;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);
  padding: 40px;
  width: 90%;
  max-width: 450px;
}

.login-header {
  text-align: center;
  margin-bottom: 30px;
}

.login-header h1 {
  color: #022423;
  font-size: 32px;
  font-weight: 800;
  margin-bottom: 10px;
}

.login-header h2 {
  color: #bba67b;
  font-size: 18px;
  font-weight: 600;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  color: #022423;
  font-weight: 700;
  font-size: 16px;
}

.form-group input {
  padding: 12px 15px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 16px;
  transition: all 0.3s ease;
  font-family: 'Cairo', Arial, sans-serif;
}

.form-group input:focus {
  outline: none;
  border-color: #bba67b;
  box-shadow: 0 0 0 3px rgba(187, 166, 123, 0.1);
}

.error-message {
  background: #ffe6e6;
  color: #c00;
  padding: 12px;
  border-radius: 8px;
  text-align: center;
  font-weight: 600;
  border: 1px solid #ffcccc;
}

.login-button {
  background: linear-gradient(135deg, #022423 0%, #034544 100%);
  color: white;
  padding: 14px;
  border: none;
  border-radius: 8px;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: 'Cairo', Arial, sans-serif;
  margin-top: 10px;
}

.login-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(2, 36, 35, 0.3);
}

.login-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.login-footer {
  text-align: center;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 2px solid #f0f0f0;
}

.login-footer p {
  color: #666;
  font-weight: 600;
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/components/Login.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0EAA0E;EAC1E,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":[".login-container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #022423 0%, #034544 50%, #022423 100%);\n  direction: rtl;\n  font-family: 'Cairo', Arial, sans-serif;\n}\n\n.login-box {\n  background: white;\n  border-radius: 20px;\n  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);\n  padding: 40px;\n  width: 90%;\n  max-width: 450px;\n}\n\n.login-header {\n  text-align: center;\n  margin-bottom: 30px;\n}\n\n.login-header h1 {\n  color: #022423;\n  font-size: 32px;\n  font-weight: 800;\n  margin-bottom: 10px;\n}\n\n.login-header h2 {\n  color: #bba67b;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form-group label {\n  color: #022423;\n  font-weight: 700;\n  font-size: 16px;\n}\n\n.form-group input {\n  padding: 12px 15px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 16px;\n  transition: all 0.3s ease;\n  font-family: 'Cairo', Arial, sans-serif;\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: #bba67b;\n  box-shadow: 0 0 0 3px rgba(187, 166, 123, 0.1);\n}\n\n.error-message {\n  background: #ffe6e6;\n  color: #c00;\n  padding: 12px;\n  border-radius: 8px;\n  text-align: center;\n  font-weight: 600;\n  border: 1px solid #ffcccc;\n}\n\n.login-button {\n  background: linear-gradient(135deg, #022423 0%, #034544 100%);\n  color: white;\n  padding: 14px;\n  border: none;\n  border-radius: 8px;\n  font-size: 18px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: 'Cairo', Arial, sans-serif;\n  margin-top: 10px;\n}\n\n.login-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 5px 15px rgba(2, 36, 35, 0.3);\n}\n\n.login-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.login-footer {\n  text-align: center;\n  margin-top: 30px;\n  padding-top: 20px;\n  border-top: 2px solid #f0f0f0;\n}\n\n.login-footer p {\n  color: #666;\n  font-weight: 600;\n  font-size: 14px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
